import { t } from '@lingui/core/macro'
import { Trans } from '@lingui/react/macro'

import { ConsentCheckbox } from '../ConsentCheckbox'
import { ConsentSection } from '../ConsentSection'
import { ConsentSectionFieldsProps } from '../types'

export function FreeChoiceConsentSection({ consents, updateConsent }: ConsentSectionFieldsProps) {
  return (
    <ConsentSection title={t`Free Choice Confirmation`} required>
      <p className="text-sm text-gray-600">
        <Trans>In accordance with regulations, you must confirm that you are choosing this teleconsultation of your own free will.</Trans>
      </p>
      <ConsentCheckbox
        name="freeChoice"
        label={t`I confirm that I am choosing this teleconsultation of my own free will. This consultation has not been imposed on me and I understand that I can also have an in-person consultation if I wish.`}
        checked={consents.freeChoice}
        onChange={(checked) => updateConsent('freeChoice', checked)}
        required
      />
    </ConsentSection>
  )
}
